import React from 'react';
import { SdmDialog, SdmTypography } from 'components';

function DropZoneErrorDialog({
  onClose,
  onAccept = false,
  i18n,
  requiredMembers,
}) {
  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 16 }}>
        <SdmTypography
          variant={'h1'}
          style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>
      </div>
    );
  };
  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.agree}
      onAgree={() => (onAccept ? onAccept() : onClose())}
      paperStyle={{
        borderRadius: 15,
        width: 410,
        paddingBottom: 16,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionStyle={{ height: 40, width: 158, margin: 0 }}
      actionTextStyle={{ fontSize: 20 }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 22,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
      handleBody={false}
    >
      <div
        style={{
          width: 330,
          textAlign: 'center',
          fontSize: 20,
        }}
      >
        {i18n.body}
        {requiredMembers?.length ? (
          <ul>
            {requiredMembers.map((r, idx) => (
              <li key={idx} style={{ textAlign: 'left' }}>
                {r}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </SdmDialog>
  );
}

export default DropZoneErrorDialog;
